// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ModalSaveAndSyncButtons_errorMessage__2xCil"};